import { auth } from "../../../libs/firebase";
import { MutationRootResolvers } from "../../../store/types";

export const signOut: MutationRootResolvers["signOut"] = async () => {
  await auth.signOut();

  return true;
};
